// @ts-strict-ignore
import { DashboardCard } from "@dashboard/components/Card";
import RichTextEditor from "@dashboard/components/RichTextEditor";
import { RichTextEditorLoading } from "@dashboard/components/RichTextEditor/RichTextEditorLoading";
import { useTopDescriptionRichTextContext } from "@dashboard/utils/richText/context";
import React from "react";

interface TopDescriptionCardProps {
  disabled?: boolean;
}

export const TopDescriptionCard = ({ disabled }: TopDescriptionCardProps) => {
  const { editorRef, defaultValue, isReadyForMount, handleChange } =
    useTopDescriptionRichTextContext();

  return (
    <DashboardCard>
      <DashboardCard.Header>
        <DashboardCard.Title>Top Description</DashboardCard.Title>
        <DashboardCard.Subtitle>
          Displayed above the main product description on the storefront.
        </DashboardCard.Subtitle>
      </DashboardCard.Header>
      <DashboardCard.Content>
        {isReadyForMount ? (
          <RichTextEditor
            editorRef={editorRef}
            defaultValue={defaultValue}
            onChange={handleChange}
            disabled={disabled}
            error={false}
            label="Top Description"
            name="top_description"
          />
        ) : (
          <RichTextEditorLoading label="Top Description" name="top_description" />
        )}
      </DashboardCard.Content>
    </DashboardCard>
  );
};
